import { render } from "./ClientsListPage.vue?vue&type=template&id=0a904248&scoped=true"
import script from "./ClientsListPage.vue?vue&type=script&lang=js"
export * from "./ClientsListPage.vue?vue&type=script&lang=js"

import "./ClientsListPage.vue?vue&type=style&index=0&id=0a904248&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a904248"]])

export default __exports__